import { type FieldDatatype } from '../../datatype/Datatype.ts';
import { type IBaseConditionOperatorType } from './IConditionOperator.ts';
import { ConditionOperatorAtleastOneType } from './repository/array/ConditionOperatorAtleastOne.type.ts';
import { ConditionOperatorContainsNoOne } from './repository/array/ConditionOperatorContainsNoOne.type.ts';
import { ConditionOperatorContainsOne } from './repository/array/ConditionOperatorContainsOne.type.ts';
import { ConditionOperatorCountEquals } from './repository/array/ConditionOperatorCountEquals.type.ts';
import { ConditionOperatorCountGreater } from './repository/array/ConditionOperatorCountGreater.type.ts';
import { ConditionOperatorCountLower } from './repository/array/ConditionOperatorCountLower.type.ts';
import { ConditionOperatorEmptyItemType } from './repository/array/ConditionOperatorEmptyItem.type.ts';
import { ConditionOperatorEveryOneType } from './repository/array/ConditionOperatorEveryOne.type.ts';
import { ConditionOperatorNotEmptyItemType } from './repository/array/ConditionOperatorNotEmptyItem.type.ts';
import { ConditionOperatorDefinedType } from './repository/ConditionOperatorDefined.type.ts';
import { ConditionOperatorEqualsType } from './repository/ConditionOperatorEquals.type.ts';
import { ConditionOperatorGreaterType } from './repository/ConditionOperatorGreater.type.ts';
import { ConditionOperatorInType } from './repository/ConditionOperatorIn.type.ts';
import { ConditionOperatorLowerType } from './repository/ConditionOperatorLower.type.ts';
import { ConditionOperatorNotDefinedType } from './repository/ConditionOperatorNotDefined.type.ts';
import { ConditionOperatorNotEqualsType } from './repository/ConditionOperatorNotEquals.type.ts';
import { ConditionOperatorNotInType } from './repository/ConditionOperatorNotIn.type.ts';
import { ConditionOperatorMonthBetweenType } from './repository/date/ConditionOperatorMonthBetween.type.ts';
import { ConditionOperatorCaseInsensitiveEqualsType } from './repository/string/ConditionOperatorCaseInsensitiveEquals.type.ts';
import { ConditionOperatorStringMatchesFormatType } from './repository/string/ConditionOperatorStringMatchesFormat.type.ts';
import { ConditionOperatorStringMatchesRegexType } from './repository/string/ConditionOperatorStringMatchesRegex.type.ts';
import { ConditionOperatorStringNotMatchesFormatType } from './repository/string/ConditionOperatorStringNotMatchesFormat.type.ts';

export const OperatorsRepository = {
  types: [
    // Definizione
    ConditionOperatorNotDefinedType,
    ConditionOperatorDefinedType,
    // Confronto con valori
    ConditionOperatorEqualsType,
    ConditionOperatorCaseInsensitiveEqualsType,
    ConditionOperatorNotEqualsType,
    ConditionOperatorGreaterType,
    ConditionOperatorLowerType,
    // Confronto con liste
    ConditionOperatorNotInType,
    ConditionOperatorInType,
    // Array (oggetti)
    ConditionOperatorAtleastOneType,
    ConditionOperatorEveryOneType,
    // Array (plain)
    ConditionOperatorContainsOne,
    ConditionOperatorContainsNoOne,
    // Conteggio
    ConditionOperatorCountEquals,
    ConditionOperatorCountGreater,
    ConditionOperatorCountLower,
    ConditionOperatorNotEmptyItemType,
    ConditionOperatorEmptyItemType,
    // Stringhe
    ConditionOperatorStringMatchesFormatType,
    ConditionOperatorStringNotMatchesFormatType,
    ConditionOperatorStringMatchesRegexType,
    // Date
    ConditionOperatorMonthBetweenType,
  ] as IBaseConditionOperatorType[],
  forField: (field: FieldDatatype) => {
    return OperatorsRepository.types.filter(operator =>
      operator.allowsField(field),
    );
  },
  get: (type: string | null | undefined) => {
    return type == null
      ? null
      : OperatorsRepository.types.find(operator => operator.code === type);
  },
};
